import mock from "../mock"

export const searchResult = [
  {
    groupTitle: "Pages",
    searchLimit: 4,
    data: [
      {
        id: 1,
        target: "AnalyticsDashboard",
        title: "Analytics Dashboard",
        link: "/",
        icon: "Home"
      },
    
  {
    id: 2,
    target: "my_answers",
    title: "My Answers",
    link: "/tutor/answers",
    icon: "Copy"
  },
  {
    id: 3,
    target: "my_topics",
    title: "My Topics",
    link: "/tutor/topics",
    icon: "Server"
  },
  {
    id: 4,
    target: "invite_students",
    title: "Invite Students",
    link: "/tutor/invitations",
    icon: "Send"
  },
  {
    id: 5,
    target: "notifications",
    title: "Notifications",
    link: "/tutor/notifications",
    icon: "Bell"
  },
  {
    id: 6,
    target: "my_subjects",
    title: "My Subjects",
    link: "/tutor/subjects",
    icon: "Book"
  },
  {
    id: 7,
    target: "my_education",
    title: "My Education",
    link: "/tutor/education",
    icon: "Book"
  },
  {
    id: 8,
    target: "my_experience",
    title: "My Experience",
    link: "/tutor/experience",
    icon: "Clock"
  }
    ]
  },
  {
    groupTitle: "Files",
    searchLimit: 4,
    data: [
      {
        title: "Passport Image",
        by: "Oliver Queen",
        size: "52kb",
        file: require("../../assets/img/icons/jpg.png")
      },
      {
        title: "Parenting Guide",
        by: "Alfred Pennyworth",
        size: "2.3mb",
        file: require("../../assets/img/icons/doc.png")
      },
      {
        title: "Class Notes",
        by: "Barry Allen",
        size: "30kb",
        file: require("../../assets/img/icons/doc.png")
      },
      {
        title: "Class Attendance",
        by: "Walter White",
        size: "52mb",
        file: require("../../assets/img/icons/xls.png")
      }
    ]
  },
  {
    groupTitle: "Contacts",
    searchLimit: 4,
    data: [
      {
        title: "Mia Davis",
        email: "miadavis@teleworm.us",
        img: require("../../assets/img/portrait/small/avatar-s-8.jpg"),
        date: "01/03/2020"
      },
      {
        title: "Norris Carrière",
        email: "NorrisCarriere@rhyta.com",
        img: require("../../assets/img/portrait/small/avatar-s-3.jpg"),
        date: "07/03/2020"
      },
      {
        title: "Charlotte Gordon",
        email: "CharlotteGordon@jourrapide.com",
        img: require("../../assets/img/portrait/small/avatar-s-26.jpg"),
        date: "14/03/2020"
      },
      {
        title: "Robert Nash",
        email: "RobertNash@dayrep.com",
        img: require("../../assets/img/portrait/small/avatar-s-25.jpg"),
        date: "21/03/2020"
      }
    ]
  }
]

mock.onGet("/api/main-search/data").reply(200, {
  searchResult
})
